import { Box, IconButton, Typography } from "@mui/material"
import { icons } from "../../utils"
import useStyles from "./style"

const Footer = () => {
  const classes = useStyles()
  return (
    <Box className={classes.footerContainer}>
      <Box className={classes.footerText}>
        <Typography>© 2021 Clínica de Oftalmología Sandiego Cúcuta</Typography>
      </Box>
      <Box className={classes.footerIcons}>
        <Box>
          <IconButton className={classes.icons}>
            {icons("instagram")}
          </IconButton>
        </Box>
        <Box>
          <IconButton className={classes.icons}>{icons("facebook")}</IconButton>
        </Box>
        <Box>
          <IconButton className={classes.icons}>{icons("twitter")}</IconButton>
        </Box>
      </Box>
    </Box>
  )
}

export default Footer
